import { render } from "./RejectNotificationForm.vue?vue&type=template&id=38286836&ts=true"
import script from "./RejectNotificationForm.vue?vue&type=script&lang=ts"
export * from "./RejectNotificationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__